import * as Yup from "yup";

export const validationSchemaCreateVehicleContrat = Yup.object().shape({
  contractNumber: Yup.string().required("Required field"),
  durationInMonths: Yup.string().required("Required field"),
  dateOfEntry: Yup.string().required("Required field"),
  releaseDate: Yup.string().required("Required field"),
  kmOnContract: Yup.string().required("Required field"),
  numberOfWinterTires: Yup.string().notRequired(),
  numberOfSummerTires: Yup.string().notRequired(),
  rentExcludingTax: Yup.string().required("Required field"),
  periodicity: Yup.string()
    .transform((curr, orig) => (orig && typeof orig === "object" ? orig.value : curr))
    .required("Required field"),
  owner_company_id: Yup.string().notRequired(),
});

interface FormValuesVehicleContrat {
  contractNumber: string;
  durationInMonths: string;
  dateOfEntry: string;
  releaseDate: string;
  kmOnContract: string;
  numberOfWinterTires: string;
  numberOfSummerTires: string;
  rentExcludingTax: string;
  periodicity: string;
  owner_company_id: string;
}

export const initialValuesVehicleContrat: FormValuesVehicleContrat = {
  contractNumber: "",
  durationInMonths: "",
  dateOfEntry: "",
  releaseDate: "",
  kmOnContract: "",
  numberOfWinterTires: "",
  numberOfSummerTires: "",
  rentExcludingTax: "",
  periodicity: "",
  owner_company_id: "",
};
